export { useLineOfCoverageOptions } from './options';
